export enum TipoPreguntaForo {
    ANUNCIO = 'anuncio',
    AYUDA = 'ayuda',
    NOTIFICACION_ERROR = 'notificacion_error',
    SUGERENCIA = 'sugerencia',
    PROYECTO = 'proyecto',
}